/**
* Testimonials Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Testimonials Slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

( function( app ) {
  const COMPONENT = {

    className: 'video-testimonials-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      function videoSlickInit() {
        let sliderCounter = 0;
        let sliderElements = '';

        if ( $( '.video-testimonials-slider' ).length ) {
          sliderCounter++;
          if ( sliderElements === '' ) {
            sliderElements += '.video-testimonials-slider';
          } else {
            sliderElements += ', .video-testimonials-slider';
          }
        }

        if ( $( '.ll-testimonials-slider__slide' ).length >= 2 ) {
          $( '.ll-testimonials-slider__slider' ).slick( {
            dots: true,
            arrows: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            mobileFirst: true,

            responsive: [
              {
                breakpoint: 1024,
                settings: 'unslick',
              },
              {
                breakpoint: 768,
                settings: {
                  dots: true,
                  arrows: false,
                  slidesToShow: 2,
                  slidesToScroll: 1,
                },
              },
            ],
          } );
        }
      }

      $( window ).on( 'load resize orientationchange', function() {
        $( '.ll-testimonials-slider__slider' ).each( function() {
          const $carousel = $( this );
          /* Initializes a slick carousel only on mobile screens */
          // slick on mobile
          if ( $( window ).width() > 1024 ) {
            if ( $carousel.hasClass( 'slick-initialized' ) ) {
              videoSlickInit();
            }
          } else {
            if ( !$carousel.hasClass( 'slick-initialized' ) ) {
              videoSlickInit();
            }
          }
        } );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'video-testimonials-slider', COMPONENT );
} )( app );
